var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Suspense, } from 'react';
import { TranslationProvider } from '@storebrand-digital/fms-translations-react';
import { FooterBase } from './styled';
import config from '../../../package.json';
import en from '../../translation/backup/fallback-en.json';
import no from '../../translation/backup/fallback-no.json';
function Footer(_a) {
    var children = _a.children, props = __rest(_a, ["children"]) // eslint-disable-line
    ;
    return (React.createElement(TranslationProvider, { document: "footer", clientId: config.name, fallback: { no: no, en: en } },
        React.createElement(Suspense, { fallback: React.createElement("div", null) },
            React.createElement(FooterBase, null, children))));
}
export default Footer;
